import ArrowLeft from "../../assets/icons/Arrow/ArrowLeft";
import { useRightPanel } from "../../context/RightPanelContext";
import {
  countQuantityCart,
  getProductById,
} from "../../services/cartShoppingService";
import { RootState } from "../../store/store";
import { displayNumber, getPrice } from "../../utils/getPrice";
import ShoppingCartItem from "../ShoppingCartItem/ShoppingCartItem";
import "./RightPanel.scss";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const _computeTotalPrice = (
  shoppingCart: any,
  products: any,
  reduc: number
) => {
  let price = 0,
    tva = 0;

  shoppingCart.forEach((item: any) => {
    if (products?.[item.productCode]) {
      price +=
        item.quantity *
        Number(getPrice(products[item.productCode].PrixHT, reduc));
      tva +=
        (item.quantity *
          Number(getPrice(products[item.productCode].PrixHT, reduc)) *
          products[item.productCode].TVATaux) /
        100;
    }
  });
  return {
    price,
    tva,
    total: price + tva,
  };
};

const RightPanel = ({ show }: { show: boolean }) => {
  const { shoppingCart } = useSelector((state: RootState) => state.cart);
  const { closePanel } = useRightPanel();
  const navigate = useNavigate();
  const [products, setProducts] = useState<any>({});
  const { user } = useSelector((state: RootState) => state.user);

  useEffect(() => {
    if (shoppingCart?.length > 0) {
      shoppingCart.forEach((item) => {
        if (!Object.keys(products).includes(item.productCode)) {
          getProductById(item.productCode).then((res) =>
            setProducts((products: any) => ({
              ...products,
              [item.productCode]: res,
            }))
          );
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shoppingCart]);

  const pricing = useMemo(
    () => _computeTotalPrice(shoppingCart, products, user?.discountRate ?? 0),
    [shoppingCart, products, user]
  );

  const goToProduct = ({
    categoryCode,
    subCategoryCode,
    code,
  }: {
    categoryCode?: string;
    subCategoryCode?: string;
    code?: string;
  }) => {
    navigate(`/category-product/${categoryCode}/${subCategoryCode}/${code}`, {
      replace: true,
    });
  };

  return (
    <div className="right-panel-container">
      <div
        className="overlay"
        onClick={closePanel}
        style={{ opacity: show ? 1 : 0, zIndex: show ? 1001 : -1 }}
      />
      <div className={`right-panel ${show ? "active" : "inactive"}`}>
        <h3>VOTRE PANIER</h3>
        {shoppingCart?.length > 0 ? (
          <div className="shopping-cart-items">
            {shoppingCart.map((item) => (
              <ShoppingCartItem
                key={item.productCode}
                product={products?.[item.productCode]}
                quantity={item.quantity}
                goTo={goToProduct}
              />
            ))}
          </div>
        ) : (
          <div>Pas d'article dans le panier</div>
        )}
        <div className="recap-cart">
          <div>
            <span>{countQuantityCart(shoppingCart)} articles</span>
            <span>{displayNumber(pricing.price)} €</span>
          </div>
          <span />
          <div>
            <span>Total (HT)</span>
            <span>{displayNumber(pricing.price)} €</span>
          </div>
          <div>
            <span>TVA</span>
            <span>{displayNumber(pricing.tva)} €</span>
          </div>
          <div>
            <span>Total (TTC)</span>
            <span>{displayNumber(pricing.total)} €</span>
          </div>
        </div>

        <div className="action-cart">
          <button onClick={() => closePanel()}>
            <ArrowLeft /> Continuer mes achats
          </button>
          {shoppingCart.length > 0 && (
            <button onClick={() => navigate("/order")}>Commander</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default RightPanel;
